import { render, staticRenderFns } from "./new2.vue?vue&type=template&id=569f1f8e&scoped=true&"
import script from "./new2.vue?vue&type=script&lang=js&"
export * from "./new2.vue?vue&type=script&lang=js&"
import style0 from "./new2.vue?vue&type=style&index=0&id=569f1f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f1f8e",
  null
  
)

export default component.exports